import React from 'react';
import '../styles/Footer.css'; 

const Footer = () => {
  return (
    <div className="footer">
      <div className="footer-container">
        {/* Logo Section */}
        <a href="https://wa.me/918949471009" target="_blank" rel="noopener noreferrer">
        <div className=" footer-logo-section logo-section">
        <img src="lightLogo.gif" alt="Mahadev Book Logo" className="footer-cus-img" />
        <img src="cards.gif" alt="Mahadev Book Logo" className="footer-cus-card" />
        </div>
        </a>

        {/* Customer Care Section */}
        <div className="customer-care">
          <h2>Get In Touch With Mahadev Book Customer Care</h2>
          <p>
            For Any Queries, Emergencies, Feedbacks or Complaints. We Are Here To Help
            You 24/7 With Our Online Services.
          </p>
          <h3>Whatsapp us on</h3>
          <a href={`https://wa.me/918949471009`} className="whatsApp-btn">+44 7418 375763</a>
        

        {/* Step-By-Step Guide Section */}
        <div className="step-guide">
          <h3>With Our Step-By-Step Guide For Beginners</h3>
          <a href={`https://wa.me/918949471009`} className="guide-btn">+44 7477 180422</a>
        </div>

        {/* Footer Disclaimer */}
        <div className="disclaimer">
          <span className="disclaimer">⚠️ Underage gambling is an offence</span> &nbsp;&nbsp; &nbsp;
          <span className="disclaimer">🌍 Restricted territories</span>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
